import React from 'react';
import { Icon } from './Icon.js';
export const IconMoveObjDownRightFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M15.25,9.99c-.414,0-.75,.336-.75,.75v2.7l-3.72-3.72c-.293-.293-.768-.293-1.061,0s-.293,.768,0,1.061l3.72,3.72h-2.7c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75h4.51c.414,0,.75-.336,.75-.75v-4.51c0-.414-.336-.75-.75-.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "2", y: "2", width: "7", height: "7", rx: "1.75", ry: "1.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconMoveObjDownRightFill18.js.map